/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

// Search
export const AZURE_BENEFIT_REQUESTS_SEARCH = "AZURE_BENEFIT_REQUESTS_SEARCH";
export const AZURE_BENEFIT_REQUESTS_SEARCH_SUCCESS = "AZURE_BENEFIT_REQUESTS_SEARCH_SUCCESS";
export const AZURE_BENEFIT_REQUESTS_SEARCH_FAIL = "AZURE_BENEFIT_REQUESTS_SEARCH_FAIL";

// Filters
export const AZURE_BENEFIT_REQUESTS_FILTER_VALUE_ADD = "AZURE_BENEFIT_REQUESTS_FILTER_VALUE_ADD";
export const AZURE_BENEFIT_REQUESTS_FILTER_VALUE_CLEAR =
  "AZURE_BENEFIT_REQUESTS_FILTER_VALUE_CLEAR";
export const AZURE_BENEFIT_REQUESTS_FILTER_VALUE_REMOVE =
  "AZURE_BENEFIT_REQUESTS_FILTER_VALUE_REMOVE";
export const AZURE_BENEFIT_REQUESTS_FILTER_VALUE_UPDATE =
  "AZURE_BENEFIT_REQUESTS_FILTER_VALUE_UPDATE";

// Individual request details
export const GET_AZURE_BENEFIT_REQUEST_DETAILS = "GET_AZURE_BENEFIT_REQUEST_DETAILS";
export const GET_AZURE_BENEFIT_REQUEST_DETAILS_SUCCESS =
  "GET_AZURE_BENEFIT_REQUEST_DETAILS_SUCCESS";
export const GET_AZURE_BENEFIT_REQUEST_DETAILS_FAIL = "GET_AZURE_BENEFIT_REQUEST_DETAILS_FAIL";

// Approve or Decline
export const AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE = "AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE";
export const AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE_FAILURE =
  "AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE_FAILURE";
export const AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE_SUCCESS =
  "AZURE_BENEFIT_REQUEST_APPROVE_OR_DECLINE_SUCCESS";
